import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CFTableColumn, CfTableColumnAlignment, CFTableColumnButtonClicked, CfTableColumnType, CfTableComponent, CFTableData, CFTablePaginationOptions, CFTableRow } from '../ui/cf-table/cf-table.component';
import { UserService } from '@aifs-shared/user/user.service';
import { UiModalService } from '../ui/ui-modal.service';
import { CFLoaderSize, CFLoaderStyle, CfLoaderComponent } from '../ui/cf-loader/cf-loader.component';
import { CFButtonStyle, CFButtonType, CfButtonComponent } from '../ui/cf-button/cf-button.component';
import { CAutoAbeonaUser, CAutoApplication, CAutoApplicationsResponse, CAutoService, CAutoUsersResponse } from './cauto.service';
import { BaseResponse } from '@aifs-shared/common/base-response';
import { CfFilterComponent } from '../ui/cf-filter/cf-filter.component';

@Component({
    selector: 'app-test-panel',
    imports: [CommonModule, RouterModule, CfTableComponent, CfLoaderComponent, CfButtonComponent, CfFilterComponent],
    providers: [CAutoService],
    templateUrl: './test-panel.component.html',
    styleUrl: './test-panel.component.scss'
})
export class TestPanelComponent implements OnInit {
    constructor(
        private router: Router,
        private userService: UserService,
        private modalService: UiModalService,
        private cautoService: CAutoService) { }

    ngOnInit(): void {
        this.currentUserId = this.userService.user()?.id ?? 0;
        this.getCAutoApplicants();
    }

    getCAutoAbeonaUsers() {
        this.loading = true;
        this.activeTab = Tab.Abeona;
        this.sortTable = this.emptyTable;
        this.filterSearchTable = this.emptyTable;

        this.cautoService.getCAutoAbeonaUsers().subscribe({
            next: (r: CAutoUsersResponse) => {
                this.cautoAbeonaUsers = r.users;
                this.populateAbeonaUsersTable(this.cautoAbeonaUsers);
                this.loading = false;
            },
            error: this.handleError.bind(this, 'CAuto abeona user retrieval')
        });
    }

    getCAutoApplicants() {
        this.loading = true;
        this.activeTab = Tab.CA18;
        this.filterSearchTable = this.emptyTable;

        this.cautoService.getCAutoApplications().subscribe({
            next: (r: CAutoApplicationsResponse) => {
                this.cautoApplications = r.applications;
                this.populateApplicationsTable(this.cautoApplications);
                this.loading = false;
            },
            error: this.handleError.bind(this, 'CAuto abeona applications retrieval')
        });
    }


    rowButtonClicked(event: CFTableColumnButtonClicked): void {
        const userId = event.pk;
        switch (event.text) {
            case ButtonText.PlaceAtTestCamp:
                this.placeApplicantAtTestCamp(userId);
                break;
            case ButtonText.CreateVisaDetails:
                this.createTestOrcaVisaDetails(userId);
                break;
            case ButtonText.CreateFlightDetails:
                this.createTestFlightDetails(userId);
                break;
            case ButtonText.AssignSelf:
                this.assignUserToSelf(userId);
                break;
            case ButtonText.ResetUser:
                if (this.activeTab == Tab.CA18) {
                    this.resetApplicant(userId);
                }
                else if (this.activeTab == Tab.Abeona) {
                    let fullName = this.filterSearchTable?.rows?.find(e => e.pk == userId)?.cols[2];
                    let dotPosition = fullName?.lastIndexOf('.') ?? 0;
                    let name = fullName?.substring(dotPosition + 1);
                    if (name) {
                        this.resetAbeonaUser(name);
                    }
                }
                break;
        }
    }

    resetApplicant(userId: string) {
        console.log('nope')
    }

    resetAbeonaUser(name: string) {
        this.loading = true;
        this.modalService.showModalInformation('Reset in progress', `We are currently processing your user reset request for ${name}. Please wait for the user list to show.`)
        this.cautoService.resetAbeonaUser(name).subscribe({
            next: (response: BaseResponse) => {
                this.loading = false;
            },
            error: this.handleError.bind(this, 'CAuto abeona applications retrieval')
        });
    }

    placeApplicantAtTestCamp(userId: string) {
        this.loading = true;
        let applicantName = this.filterSearchTable?.rows?.find(e => e.pk == userId)?.cols[1];
        this.cautoService.placeApplicantAtTestCamp(parseInt(userId)).subscribe({
            next: (r: BaseResponse) => {
                this.modalService.showModalInformation('User Placed', `You have now placed ${applicantName} at Test Camp!`)
                    .subscribe({
                        next: (r: string) => {
                            this.loading = false;
                        }
                    });
            },
            error: this.handleError.bind(this, 'CAuto abeona placement process')
        })
    }

    createTestOrcaVisaDetails(userId: string) {
        this.loading = true;
        let applicantName = this.filterSearchTable?.rows?.find(e => e.pk == userId)?.cols[1];
        this.cautoService.createTestOrcaVisaDetails(parseInt(userId)).subscribe({
            next: (r: BaseResponse) => {
                this.modalService.showModalInformation('Visa Details Updated', `You have now created orca visa details for ${applicantName}!`)
                    .subscribe({
                        next: (r: string) => {
                            this.loading = false;
                        }
                    });
            },
            error: this.handleError.bind(this, 'CAuto abeona visa process')
        })
    }

    createTestFlightDetails(userId: string) {
        this.loading = true;
        let applicantName = this.filterSearchTable?.rows?.find(e => e.pk == userId)?.cols[1];
        this.cautoService.createTestFlightDetails(parseInt(userId)).subscribe({
            next: (r: BaseResponse) => {
                this.modalService.showModalInformation('Flight Details Updated', `You have now set flight details for ${applicantName}!`)
                    .subscribe({
                        next: (r: string) => {
                            this.loading = false;
                            console.log(r);
                        }
                    });
            },
            error: this.handleError.bind(this, 'CAuto abeona flight details process')
        })
    }
    assignUserToSelf(userIdToBeAssigned: string): void {
        this.loading = true;
        let userAssignedName = this.filterSearchTable?.rows?.find(e => e.pk == userIdToBeAssigned)?.cols[1];
        this.cautoService.assignCAutoAbeonaUser(this.currentUserId, parseInt(userIdToBeAssigned)).subscribe({
            next: (r: BaseResponse) => {
                this.modalService.showModalInformation('User Assigned', `You have now assigned yourself to the user ${userAssignedName}. You will act as this user the next time you log out and in again.`)
                    .subscribe({
                        next: (r: string) => {
                            this.loading = false;
                        }
                    });
            },
            error: this.handleError.bind(this, 'CAuto abeona user assign process')
        })
    }


    filter(value: string): void {
        const searchTerm = value.toLocaleLowerCase();

        this.isFilteringInProgress = true;

        if (this.activeTab == Tab.Abeona) {
            setTimeout(() => {
                let searchUsersResults = this.cautoAbeonaUsers
                    .filter((u: CAutoAbeonaUser) => {
                        return u.azureEmail.toLocaleLowerCase().includes(searchTerm)
                            || u.fullName.toLocaleLowerCase().includes(searchTerm)
                            || u.officeOrAgency.toLocaleLowerCase().includes(searchTerm)
                            || u.userId.toString().toLocaleLowerCase().includes(searchTerm)
                            || (value == 'interviewer' && u.isInterviewer)
                            || (value == 'agent' && u.isAgent)
                            || (value == 'staff' && u.isStaff)
                    });

                this.populateAbeonaUsersTable(searchUsersResults);

                this.isFilteringInProgress = false;
            }, 150);
        }
        else if (Tab.CA18 !== undefined) {
            setTimeout(() => {
                let searchApplicationsResults = this.cautoApplications
                    .filter((a: CAutoApplication) => {
                        return a.email.toLocaleLowerCase().includes(searchTerm)
                            || a.fullName.toLocaleLowerCase().includes(searchTerm)
                            || a.status.toLocaleLowerCase().includes(searchTerm)
                            || a.userId.toString().toLocaleLowerCase().includes(searchTerm)
                    });

                this.populateApplicationsTable(searchApplicationsResults);

                this.isFilteringInProgress = false;
            }, 150);
        }
    }

    filterSearchTable?: CFTableData;
    searchApplicationsResults?: CAutoApplication[] = [];
    searchUsersResults?: CAutoAbeonaUser[] = [];

    loading: boolean = false;
    activeTab: string = Tab.Abeona;
    sortTable?: CFTableData;
    emptyTable?: CFTableData;
    currentUserEmail?: string;
    loaderSize: CFLoaderSize = CFLoaderSize.Large;
    applicationButtonType: CFButtonType = CFButtonType.Primary;
    cautoAbeonaUserButtonType: CFButtonType = CFButtonType.Secondary;
    abeonaUserButtonType: CFButtonType = CFButtonType.Danger;
    currentUserId: number = 0;

    cautoAbeonaUsers: CAutoAbeonaUser[] = [];
    cautoApplications: CAutoApplication[] = [];
    isFilteringInProgress = false;

    private populateAbeonaUsersTable(searchUsersResults: CAutoAbeonaUser[]) {
        const results = searchUsersResults.map((user: CAutoAbeonaUser) => {
            let roles = [];
            if (user.isInterviewer) roles.push("Interviewer");
            if (user.isAgent) roles.push("Agent");
            if (user.isStaff) roles.push("Staff");
            return new CFTableRow(`${user.userId}`, [
                "",
                user.userId === this.userService.user()?.id ? "✅" : "",
                user.fullName,
                roles.join(", "),
                user.officeOrAgency,
                user.azureEmail,
                user.isTestUser ? ButtonText.ResetUser : "",
                user.userId != this.userService.user()?.id ? ButtonText.AssignSelf : "",
                user.isActive ? "✅" : "",
            ]);
        });


        let bc = new CFTableColumn("", CfTableColumnAlignment.Right, CfTableColumnType.Button, "abeona_reset_button");
        bc.options = { button: { type: CFButtonType.Danger } };
        let bc2 = new CFTableColumn("", CfTableColumnAlignment.Right, CfTableColumnType.Button, "abeona_assign_button");
        bc2.options = { button: { type: CFButtonType.Primary } };
        var columns: CFTableColumn[] = [
            new CFTableColumn("", CfTableColumnAlignment.Left, CfTableColumnType.UserProfile),
            new CFTableColumn("You", CfTableColumnAlignment.Left, CfTableColumnType.String),
            new CFTableColumn("Name", CfTableColumnAlignment.Left, CfTableColumnType.String),
            new CFTableColumn("Role", CfTableColumnAlignment.Left, CfTableColumnType.String),
            new CFTableColumn("Office/Agency", CfTableColumnAlignment.Center, CfTableColumnType.String),
            new CFTableColumn("Current Assignee", CfTableColumnAlignment.Right, CfTableColumnType.String),
            bc,
            bc2,
            new CFTableColumn("Active", CfTableColumnAlignment.Right, CfTableColumnType.String),
        ];

        this.filterSearchTable = new CFTableData(columns.slice(), [...results], new CFTablePaginationOptions(15, results.length));
    }

    private populateApplicationsTable(applicationsResults: CAutoApplication[]) {
        const results = applicationsResults.map((application: CAutoApplication) => {
            return new CFTableRow(`${application.userId}`, [
                "",
                application.fullName,
                application.email,
                application.status,
                ButtonText.PlaceAtTestCamp,
                ButtonText.CreateVisaDetails,
                ButtonText.CreateFlightDetails,
                application.isTestUser ? ButtonText.ResetUser : ''
            ]);
        });

        let bc = new CFTableColumn("", CfTableColumnAlignment.Right, CfTableColumnType.Button, "place_button")
        bc.options = { button: { type: CFButtonType.Primary } };
        let bc1 = new CFTableColumn("", CfTableColumnAlignment.Right, CfTableColumnType.Button, "visa_button")
        bc1.options = { button: { type: CFButtonType.Primary } };
        let bc4 = new CFTableColumn("", CfTableColumnAlignment.Right, CfTableColumnType.Button, "flights_button")
        bc4.options = { button: { type: CFButtonType.Primary } };
        let bc5 = new CFTableColumn("", CfTableColumnAlignment.Right, CfTableColumnType.Button, "applicant_reset_button")
        bc5.options = { button: { type: CFButtonType.Danger } };

        var columns: CFTableColumn[] = [
            new CFTableColumn("", CfTableColumnAlignment.Left, CfTableColumnType.UserProfile),
            new CFTableColumn("Name", CfTableColumnAlignment.Left, CfTableColumnType.String),
            new CFTableColumn("Email", CfTableColumnAlignment.Left, CfTableColumnType.String),
            new CFTableColumn("Status", CfTableColumnAlignment.Left, CfTableColumnType.UserStatus),
            bc,
            bc1,
            bc4,
            bc5
        ];

        this.filterSearchTable = new CFTableData(columns.slice(), [...results], new CFTablePaginationOptions(15, results.length));
    }

    private handleError(message: string, error: any) {
        this.modalService
            .showModalError('Server Error', `There was an error in the ${message}`)
            .subscribe({
                next: (r: string) => {
                    this.router.navigateByUrl("/cauto");
                }
            });
    }
}

enum Tab {
    Abeona = "Abeona",
    CA18 = "CA18"
}

enum ButtonText {
    PlaceAtTestCamp = 'Place at TestCamp',
    ResetUser = 'Reset User',
    CreateVisaDetails = 'Create Visa Details',
    CreateFlightDetails = 'Create Flight Details',
    AssignSelf = 'Assign Self'
}